import { render, staticRenderFns } from "./setEmail.vue?vue&type=template&id=bbccfa4e&scoped=true"
import script from "./setEmail.vue?vue&type=script&lang=js"
export * from "./setEmail.vue?vue&type=script&lang=js"
import style0 from "./setEmail.vue?vue&type=style&index=0&id=bbccfa4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbccfa4e",
  null
  
)

export default component.exports